import React from "react";
import { Box, Typography } from "@material-ui/core";
import {
  CustomCopyToClipboard,
  CustomDialog,
} from "../../../../../../../../Components";
import { useSelectedTheme, useTranslate } from "../../../../../../../../Hooks";

// styles
import useStyle from "./styles";

// icons
import {
  CertificateIcon,
  CheckIcon,
} from "../../../../../../../../assets/icons";

function CourseDetailsDialog({ onOpen, onClose, detailsCourse }) {
  const styles = useStyle();
  const { translate } = useTranslate("NewPropertiesView");
  const {
    theme: { palette },
  } = useSelectedTheme();

  return (
    <CustomDialog
      open={onOpen}
      onClose={() => {
        onClose();
      }}
      cancelText={translate("close")}
      width={"668px"}
      styleCancleButton={{
        background: "#7F6944",
        color: "#ffffff",
      }}
      headingIcon={
        <Box className={styles.containerIcon}>
          <CertificateIcon
            width="48"
            height="48"
            fill={palette.foreground.secondary}
          />
        </Box>
      }
      content={
        <Box className={styles.containerContent}>
          <Box className={styles.containerTitle}>
            <Typography className={styles.titleStyle}>
              {translate("Courses-details")}
            </Typography>
            <Typography className={styles.DescStyle}>
              {translate("Labels-help-organize-projects")}
            </Typography>
          </Box>
          <Box className={styles.containerContant}>
            <Typography className={styles.titleStyle}>
              {detailsCourse?.courseName}
            </Typography>
            <Typography className={styles.DescStyle}>
              {detailsCourse?.courseDescription}
            </Typography>
            <Box className={styles.containerModule}>
              <Typography className={styles.titleStyle}>
                {detailsCourse?.courseName}
              </Typography>
              {detailsCourse.courseModuleName.length > 0 && (
                <Box className={styles.containerCourseModuleName}>
                  {detailsCourse.courseModuleName.map((moduleName, index) => (
                    <Box
                      className={styles.containetrCourseModuleItem}
                      key={index}
                    >
                      <CheckIcon
                        width="20"
                        height="20"
                        fill={palette.foreground.brandPrimary}
                      />
                      <Typography className={styles.moduleName}>
                        {moduleName}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
            <CustomCopyToClipboard
              data={detailsCourse?.courseLink} // copy
              childrenData={detailsCourse?.courseLink} // render
              copyDoneShowTime={1000}
              fontSize="14px"
            />
          </Box>
        </Box>
      }
    />
  );
}

export default CourseDetailsDialog;
